import { classes as a } from "../classes/classes.js";
import '../assets/MessageBox.css';const o = "op_info_5FQEZ", t = "op_alert_vOxEn", l = "op_warning_c6ZH8", r = "op_success_Nmlr1", i = {
  info: o,
  alert: t,
  warning: l,
  success: r
};
function _(e) {
  let {
    messageType: c = null,
    ...s
  } = e, n = i[c];
  return /* @__PURE__ */ React.createElement("div", { role: "status", "aria-atomic": "true", ...s, className: a(n, s == null ? void 0 : s.className) }, e.children);
}
export {
  _ as MessageBox
};
